<template>
  <router-view />
</template>

<script>
  // Styles
  import '@/styles/overrides.sass'

  export default {
    name: 'LocaleLayout',
  }
</script>
